import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { EASINGS } from './_utils.js';

const variants = {
    exit: (props) => ({
        opacity: 0,
        ...(props.reverse ? { scale: props.initialScale } : { transitionEnd: { scale: props.initialScale } }),
        transition: {
            duration: 0.2,
            ease: EASINGS.easeOut,
        },
    }),
    enter: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.25,
            ease: EASINGS.easeInOut,
        },
    },
};
const scaleFadeConfig = {
    variants,
    initial: 'exit',
    animate: 'enter',
    exit: 'exit',
};
const ScaleFade = React.forwardRef((props, ref) => {
    const { reverse = true, initialScale = 0.95, unmountOnExit, visible, ...rest } = props;
    const show = unmountOnExit ? visible && unmountOnExit : true;
    const custom = React.useMemo(() => ({ initialScale, reverse }), [initialScale, reverse]);
    const motionProps = React.useMemo(() => ({
        ...scaleFadeConfig,
        custom,
        animate: visible || unmountOnExit ? 'enter' : 'exit',
    }), [custom, visible, unmountOnExit]);
    return (React.createElement(AnimatePresence, { custom: custom }, show && React.createElement(motion.div, { ref: ref, ...motionProps, ...rest })));
});
ScaleFade.defaultProps = {
    initialScale: 0.95,
    reverse: true,
};
ScaleFade.displayName = 'ScaleFade';

export { ScaleFade, scaleFadeConfig };
//# sourceMappingURL=ScaleFade.js.map
